import React, { useEffect, useState } from 'react';
import axios from '../../axiosConfig';

const ProjectsList = () => {
  const [projects, setProjects] = useState([]); // 确保初始值为数组

  useEffect(() => {
    axios.get('/jianshenxiangmu/list?7')
      .then(response => {
        console.log("response",response);
        if (Array.isArray(response.data.data.list)) {
          setProjects(response.data.data.list); // 确保数据是数组
        } else {
          console.error('Unexpected data format:', response.data);
          setProjects([]); // 如果不是数组，则设置为空数组
        }
      })
      .catch(error => {
        console.error('Error fetching projects:', error);
        setProjects([]); // 请求失败时设置为空数组
      });
  }, []);

  return (
    <div>
      <h1>Project List</h1>
      <ul>
        {projects.map(project => (
          <li key={project.id}>{project.xiangmumingcheng}</li>
        ))}
      </ul>
    </div>
  );
};

export default ProjectsList;
